const state = {
  state() {
    return {
      msalConfig: {
        auth: {
          clientId: 'b6f88a8c-1e82-40db-b634-1e27a3060492',
          authority:
            'https://login.microsoftonline.com/8282d676-993e-437c-8642-62e37fcd206d',
        },
        cache: {
          cacheLocation: 'localStorage',
        },
      },
      accessToken: ''
    };
  },
  mutations :{
    setAccessToken(state, token){
      state.accessToken = token;
    }
  }
};

export default state;